import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist'

Vue.use(Vuex)

// modules
import auth from './modules/auth';
import { constants } from './modules/constants.js';
import complains from "./modules/complains.js"
import payroll from './modules/payroll.js';

const store = new Vuex.Store({
    state: {
        loading: false,
        success: false
    },
    mutations: {
        loadingStarts(state, payload) {
            state.loading = true;
        },
        loadingEnds(state, payload) {
            state.loading = false;
        },
        succeeded(state, payload) {
            state.success = payload.message;
        }
    },
    modules: {
        auth,
        constants,
        complains,
        payroll
    }
})

new VuexPersistence({
    supportCircular: true,
    storage: window.localStorage
}).plugin(store);

export default store;



// WEBPACK FOOTER //
// ./src/store/store.js